(function (window, document) {
  "use strict";
  var themeFunctions = function (options) {
    var defaults = {
      // Defaults configuration
      deliveryDrawer: ".delivery-drawer__wrapper",
      openDeliveryButton: ".delivery-details-text",
      openDeliveryCart: ".header__delivery--dialog-cart",
      changeDeliveryButton: ".change-delivery-res",
      modalOverlay: ".modal_overlay",
      deliveryClose: ".delivery-type-close",
      searchModal: ".search-modal",
      searchClose: ".search-modal__close-button",
      menuToggles: ".submenu-link",
      sidebar: ".sidebar",
      menuItems: ".sidebar_drawer-open",
      subMenuItems: ".sidebar_subdrawer-open",
      sidebarTitle: ".sidebar-title",
      sidebarCloseButtons: ".sidebar_drawer_back",
      sidebarBackButtons: ".js-go-cart-quantity-plus",
      quickAddPlusButtons: ".collection-product__plus",
      quickAddMinusButtons: ".collection-product__minus",
      quickAddSubmitButtons: ".quick-add__submit",
      quickAddQuantityInputs: ".collection-quantity-selector",
    };

    this.settings = Object.assign({}, defaults, options);
    this.init();
    this.bindEvents();
  };

  themeFunctions.prototype.init = function () {
    this.deliveryDrawer = document.querySelector(this.settings.deliveryDrawer);
    this.openDeliveryButton = document.querySelector(
      this.settings.openDeliveryButton
    );
    this.openDeliveryCart = document.querySelector(
      this.settings.openDeliveryCart
    );
    this.changeDeliveryButton = document.querySelector(
      this.settings.changeDeliveryButton
    );
    this.modalOverlay = document.querySelector(this.settings.modalOverlay);
    this.searchModal = document.querySelector(this.settings.searchModal);
    this.searchClose = document.querySelector(this.settings.searchClose);
    this.menuToggles = document.querySelectorAll(this.settings.menuToggles);
    this.sidebar = document.querySelectorAll(this.settings.sidebar);
    this.menuItems = document.querySelectorAll(this.settings.menuItems);
    this.subMenuItems = document.querySelectorAll(this.settings.subMenuItems);
    this.sidebarTitle = document.querySelector(this.settings.sidebarTitle);
    this.sidebarCloseButtons = document.querySelectorAll(
      this.settings.sidebarCloseButtons
    );
    this.sidebarBackButtons = document.querySelectorAll(
      this.settings.sidebarBackButtons
    );
    this.quickAddPlusButtons = document.querySelectorAll(
      this.settings.quickAddPlusButtons
    );
    this.quickAddMinusButtons = document.querySelectorAll(
      this.settings.quickAddMinusButtons
    );
    this.quickAddSubmitButtons = document.querySelectorAll(
      this.settings.quickAddSubmitButtons
    );
    this.quickAddQuantityInputs = document.querySelectorAll(
      this.settings.quickAddQuantityInputs
    );
  };

  themeFunctions.prototype.bindEvents = function () {
    var self = this;

    // Assuming bodyElement needs to be defined or is accessible globally
    var bodyElement = document.body;

    themeFunctions.prototype.promptForDeliveryType = function () {
      self.modalOverlay.classList.add("submenu-open");
      document.body.classList.add("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer.classList.add("submenu-open");
    };

    themeFunctions.prototype.openDeliveryButton = function () {
      self.promptForDeliveryType();
    };

    themeFunctions.prototype.handleDeliveryDrawerClick = function () {
      self.modalOverlay.classList.add("submenu-open");
      document.body.classList.add("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer.classList.add("submenu-open");
    };

    themeFunctions.prototype.hidePromptForDeliveryType = function () {
      self.modalOverlay.classList.remove("submenu-open");
      document.body.classList.remove("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer.classList.remove("submenu-open");
    };

    document.addEventListener("click", function (event) {
      if (event.target.matches(".collection-product__plus")) {
        // Additional check for maximum quantity
        if (isDeliverySet === "true" || decideDeliveryLater === "1") {
          let parent = event.target.closest(".quick-add");
          let item = event.target.closest(".product-item");

          if (!parent) {
            console.error("Parent .quick-add not found");
            return;
          }

          let quantityInput = parent.querySelector("input");
          if (!quantityInput) {
            console.error("Input inside .quick-add not found");
            return;
          }

          let productTitle = item.getAttribute("data-title");
          if (productTitle.includes("Delivery Pass")) {
            if (parseInt(quantityInput.value) > 0) {
              console.error("Maximum quantity of Delivery Pass reached");
              item.querySelector(".product-error__container").innerHTML =
                "You can only add one Delivery Pass to the cart";
              return;
            }
          }

          let maxQuantity = parseInt(quantityInput.max);
          let currentQuantity = parseInt(quantityInput.value);

          if (isNaN(currentQuantity) || currentQuantity < maxQuantity) {
            let activeProductForms = document.querySelectorAll(
              ".quick-add product-form"
            );
            activeProductForms.forEach(function (form) {
              form.classList.add("updating-cart");
            });

            let newQuantity = currentQuantity + 1;
            quantityInput.value = newQuantity;

            let itemId = parent
              .querySelector(".quick-add__quantity")
              .getAttribute("data-id");
            let productUpdates = [{ id: itemId, quantity: newQuantity }];
            agileCart.updateItemQuantity(productUpdates);
          } else {
            // Optionally, show an error message to the user
            console.error("Maximum quantity reached");
            item.querySelector(".product-error__container").innerHTML =
              "Maximum quantity in cart";
          }
        } else {
          console.log("Delivery type is not set.");
          theme.promptForDeliveryType();
        }
      }

      if (event.target.matches(".collection-product__minus")) {
        if (isDeliverySet === "true" || decideDeliveryLater === "1") {
          // Use event.target to reference the clicked element
          let parent = event.target.closest(".quick-add");
          let item = event.target.closest(".product-item");
          if (!parent) {
            console.error("Parent .quick-add not found");
            return; // Safety check
          }
          let activeProductForms = document.querySelectorAll(
            ".quick-add product-form"
          );

          activeProductForms.forEach(function (form) {
            form.classList.add("updating-cart");
          });

          item.querySelector(".product-error__container").innerHTML = "";

          let itemId = parent
            .querySelector(".quick-add__quantity")
            .getAttribute("data-id");

          let quantityInput = parent.querySelector("input");

          if (!quantityInput) {
            console.error("Input inside .quick-add not found");
            return; // Safety check
          }

          let currentQuantity = Number(quantityInput.value);
          // When quantity is 1, we want to send 0 as the quantity and also hide the container
          if (currentQuantity === 1) {
            // Set quantity to 0
            quantityInput.value = 0;

            // Hide the quantity container
            parent.querySelector(".quick-add__quantity").style.display = "none";

            // Update the item quantity in the cart to 0
            let productUpdates = [{ id: itemId, quantity: 0 }];
            agileCart.updateItemQuantity(productUpdates);
          } else if (currentQuantity > 1) {
            // Decrement the quantity by 1 if it's more than 1
            let newQuantity = currentQuantity - 1;
            quantityInput.value = newQuantity;

            // Update the cart as usual
            let productUpdates = [{ id: itemId, quantity: newQuantity }];
            agileCart.updateItemQuantity(productUpdates);
          }
        } else {
          console.log("Delivery type is not set.");
          theme.promptForDeliveryType();
        }
      }
    });

    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    document.addEventListener(
      "input",
      debounce(function (event) {
        if (event.target.matches(".collection-quantity-selector")) {
          if (isDeliverySet === "true" || decideDeliveryLater === "1") {
            let parent = event.target.closest(".quick-add");
            let item = event.target.closest(".product-item");
            if (!parent) {
              console.error("Parent element '.quick-add' not found");
              return; // Exits if the parent container is not found
            }

            let activeProductForms = document.querySelectorAll(
              ".quick-add product-form"
            );

            activeProductForms.forEach(function (form) {
              form.classList.add("updating-cart");
            });

            const inputElement = event.target;
            const value = inputElement.value.trim();
            var itemId = parent
              .querySelector(".quick-add__quantity")
              .getAttribute("data-id");
            var quantity = parseInt(value, 10);
            var maxQuantity =
              parseInt(inputElement.getAttribute("max"), 10) || Infinity; // Use input max or fallback to Infinity

            // Handle the case when quantity is 0
            if (quantity === 0) {
              let productUpdates = [{ id: itemId, quantity: 0 }];
              agileCart.updateItemQuantity(productUpdates);
              return;
            }

            // Check if the product is a "Delivery Pass"
            let productTitle = item.getAttribute("data-title");
            if (productTitle.includes("Delivery Pass") && quantity > 1) {
              console.error("Maximum quantity of Delivery Pass reached");
              inputElement.value = 1;
              let productUpdates = [{ id: itemId, quantity: 1 }];
              agileCart.updateItemQuantity(productUpdates);
              item.querySelector(".product-error__container").innerHTML =
                "You can only add one Delivery Pass to the cart";
              return;
            }

            if (/^\d+$/.test(value) && quantity > 0) {
              if (quantity <= maxQuantity) {
                // Proceed with update if within max limit
                let productUpdates = [{ id: itemId, quantity: quantity }];
                agileCart.updateItemQuantity(productUpdates);
              } else {
                // Handle case where quantity exceeds max
                inputElement.value = maxQuantity; // Revert to max quantity
                let updatesFormatted = [{ id: itemId, quantity: maxQuantity }];
                console.log(updatesFormatted);
                agileCart.updateItemQuantity(updatesFormatted);

                // Display error message
                console.error("Quantity exceeds maximum limit.");

                let errorContainer = item.querySelector(
                  ".product-error__container"
                );
                if (errorContainer) {
                  errorContainer.innerHTML = "Quantity exceeds maximum limit";
                  setTimeout(function () {
                    errorContainer.innerHTML = "";
                  }, 2000);
                }
              }
            } else {
              console.error("Invalid quantity input:", value);
              // Optionally, reset the input to a valid value or provide feedback to the user
            }
          } else {
            console.log("Delivery type is not set.");
            theme.promptForDeliveryType();
          }
        }
      }, 500)
    );

    // Menu drawers
    function closeDrawers() {
      var drawers = document.querySelectorAll(".sidebar");
      drawers.forEach(function (drawer) {
        drawer.classList.remove("open");
      });
      self.menuItems.forEach(function (menuItem) {
        menuItem.classList.remove("active_link");
        var menuItemLink = menuItem.querySelector("a");
        menuItemLink.classList.remove("active_link");
      });
      document.querySelectorAll(".sidebar_menu button").forEach((btn) => {
        btn.classList.remove("active-button");
      });
    }

    this.menuToggles.forEach(function (menuToggle) {
      menuToggle.addEventListener("click", function (event) {
        var menuItem = this.getAttribute("data-menu-item");
        var matchingSidebar = document.querySelector(
          `.sidebar[data-menu-item="${menuItem}"]`
        );
        matchingSidebar.classList.add("open");
        bodyElement.classList.add("open__overlay");
      });
    });

    document.querySelectorAll(".sidemenu___close").forEach((button) => {
      button.addEventListener("click", function () {
        // Get the 'data-panel' attribute of the clicked button
        const panelId = this.getAttribute("data-close");
        console.log(panelId);
        // Find the panel that matches the 'data-panel' attribute
        document.querySelectorAll(`.sub-sidebar_menu`).forEach((panel) => {
          panel.classList.remove("active-panel");
        });

        // Find the close button that matches the 'data-panel' attribute
        document.querySelectorAll(`.close-sub-menus`).forEach((button) => {
          button.classList.remove("show-close-button");
        });

        // Close the matching sidebar
        const sidebar = document.querySelector(
          `.sidebar[data-menu-item="${panelId}"]`
        );
        console.log(sidebar);
        if (sidebar) {
          sidebar.querySelector(".sidebar-inner").style.width = "auto";
          sidebar.classList.remove("open");
        }

        document.querySelectorAll(".sidebar_menu button").forEach((btn) => {
          btn.classList.remove("active-button");
        });

        // Remove the overlay
        bodyElement.classList.remove("open__overlay");
      });
    });

    document.querySelectorAll(".close-sub-menus").forEach((button) => {
      button.addEventListener("click", function (event) {
        this.classList.remove("show-close-button");
        document.querySelectorAll(".sub-sidebar_menu").forEach((panel) => {
          panel.classList.remove("active-panel");
        });
      });
    });

    // Listen for clicks on elements with the class '.text-with-icon'
    document.querySelectorAll(".sidebar_menu button").forEach((button) => {
      button.addEventListener("click", function () {
        // Check if the clicked button already has the 'active-button' class
        const isActive = this.classList.contains("active-button");

        // Add 'show-close-button' class to the close button
        document
          .querySelector(".close-sub-menus")
          .classList.add("show-close-button");

        // Remove 'active-button' class from all buttons
        document.querySelectorAll(".sidebar_menu button").forEach((btn) => {
          btn.classList.remove("active-button");
        });

        if (!isActive) {
          // Add 'active-button' class to the clicked button if it wasn't active
          this.classList.add("active-button");
        }

        // Get the 'data-panel' attribute of the clicked button
        const panelId = this.getAttribute("data-panel");

        // Find the panel that matches the 'data-panel' attribute
        const panel = document.querySelector(
          '.sub-sidebar_menu[data-panel="' + panelId + '"]'
        );

        // Adjust the sidebar width
        document.querySelector(".sidebar-inner").style.width = panel
          ? "700px"
          : "auto";

        // Close all panels except the one that matches the clicked button
        document.querySelectorAll(".sub-sidebar_menu").forEach((otherPanel) => {
          if (otherPanel !== panel) {
            otherPanel.classList.remove("active-panel");
          }
        });

        // If the matching panel exists and it's not currently active, activate it
        if (panel && !panel.classList.contains("active-panel")) {
          panel.classList.add("active-panel");
        } else if (panel && panel.classList.contains("active-panel")) {
          // If the panel is already active, deactivate it and reset sidebar width
          panel.classList.remove("active-panel");
          document.querySelector(".sidebar-inner").style.width = "auto";
        }

        // Update link and drawer states accordingly
        document
          .querySelectorAll(".sidebar_subdrawer-open a")
          .forEach((link) => {
            link.classList.remove("active_link");
          });

        document.querySelectorAll(".sidebar_subdrawer").forEach((drawer) => {
          drawer.classList.remove("open");
        });

        // Only for the active panel, add 'active_link' and 'open' to related elements
        if (panel && panel.classList.contains("active-panel")) {
          // Add any additional actions for the active panel if needed
        }
      });
    });

    this.sidebarCloseButtons.forEach(function (closeButton) {
      closeButton.addEventListener("click", function (event) {
        event.stopPropagation();
        closeDrawers();
        document.querySelector(".sidebar-inner").style.width = "auto";
        document.querySelectorAll(".sub-sidebar_menu").forEach((panel) => {
          panel.classList.remove("active-panel");
        });
        bodyElement.classList.remove("open__overlay");
      });
    });

    this.sidebarBackButtons.forEach(function (backButton) {
      backButton.addEventListener("click", function (event) {
        closeDrawers();
      });
    });

    this.menuItems.forEach(function (menuItem) {
      var drawer = menuItem.querySelector(".sidebar_drawer");
      var menuItemLink = menuItem.querySelector("a");
      menuItemLink.addEventListener("click", function (event) {
        event.preventDefault();
        closeDrawers();
        this.classList.add("active_link");
        drawer.classList.toggle("open");
        self.sidebar.classList.add("submenu-active");
      });
    });

    this.subMenuItems.forEach(function (subMenuItem) {
      var subDrawer = subMenuItem.querySelector(".sidebar_subdrawer");
      var menuItemLink = subMenuItem.querySelector("a");
      menuItemLink.addEventListener("click", function (event) {
        event.preventDefault();
        this.classList.toggle("active_link");
        subDrawer.classList.toggle("open");
      });
    });

    document
      .querySelector(".delivery-type-close")
      .addEventListener("click", function () {
        self.deliveryDrawer.classList.remove("submenu-open");
        bodyElement.classList.remove("open__overlay", "overflow-hidden-tablet");
      });        

    this.searchClose.addEventListener("click", function () {
      self.searchModal.classList.remove("open_modal");
      bodyElement.classList.remove("open__overlay", "overflow-hidden-tablet");
    });

    this.modalOverlay.addEventListener("click", function (event) {
      self.modalOverlay.classList.remove("submenu-open");
      bodyElement.classList.remove("open__overlay", "overflow-hidden-tablet");
      self.deliveryDrawer.classList.remove("submenu-open");
      self.searchModal.classList.remove("open_modal");
      document.querySelector(".sidebar-inner").style.width = "auto";
      document.querySelectorAll(".sub-sidebar_menu").forEach((panel) => {
        panel.classList.remove("active-panel");
      });
      document.querySelectorAll(".search-input").forEach((input) => {
        input.value = "";
        input.textContent = "";
      });
      closeDrawers();
    });

    if (!bodyElement.classList.contains("template-cart")) {
      var searchBar = document.getElementById("Search-In-Template");
      const overlayInput = document.getElementById("Search-In-Modal");
      searchBar.onclick = function () {
        self.modalOverlay.classList.add("submenu-open");
        bodyElement.classList.add("open__overlay", "overflow-hidden-tablet");
        self.searchModal.classList.add("open_modal");
        overlayInput.focus();
      };
    }
  };

  var theme = new themeFunctions();
  window.theme = theme;
  
})(window, document);

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!
var yyyy = today.getFullYear();
if (dd < 10) {
  dd = "0" + dd;
}
if (mm < 10) {
  mm = "0" + mm;
}
var isVIP = false;
var isGold = false;
var isFirstThreeOrders = false;
var weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

processPickingStoreCollections();

// Certain collections need to be picking store specific if non 73 also hide certain collections based on picking store.
function processPickingStoreCollections() {
  let pickingStore = $.cookie("picking_store");

  let url = window.location.href;
  let filename = url.substring(url.lastIndexOf("/") + 1);
  let appendFilename = pickingStore && pickingStore != 73 ? "-" + pickingStore : "";
  let collections = [
    "online-specials",
    "fruit-and-veg-specials",
    "grocery-specials",
    "fridge-specials",
    "butcher-specials",
    "seafood-specials",
    "liquor-specials",
    "ready-to-cook",
    "mothers-day",
  ];

  let hidePickingStoreCollections = {
    63: ["pet-needs", "gift-cards"],
    54: ["pet-needs","gift-cards"],
    49: ["pet-needs","gift-cards"],
    24: ["pet-needs","gift-cards"],
    70: ["flowers","gift-cards"],
    74: ["flowers","gift-cards"],
    75: ["flowers","gift-cards"],
    57: ["pet-needs", "vitamins-supplements","gift-cards"],
    76: ["gift-cards"],
    37: ["gift-cards"],
    66: ["gift-cards"],
    40: ["vitamins-supplements", "gift-cards"],
    52: ["gift-cards"],
    56: ["gift-cards"],
    48: ["gift-cards"],
    32: ["pet-needs","vitamins-supplements", "gift-cards"],
    51: ["gift-cards"],
    44: ["vitamins-supplements", "gift-cards"],
    10: ["pet-needs", "vitamins-supplements", "gift-cards"],
  };

  let urlPath = window.location.pathname;
  let collectionHandle =
    urlPath.split("/").filter((part) => part === "collections").length > 0
      ? urlPath.split("/").pop()
      : null;

  if (hidePickingStoreCollections.hasOwnProperty(pickingStore)) {
    localStorage.setItem("hiddenCollections", "true");
  } else {
    localStorage.setItem("hiddenCollections", "false");
  }

  function checkAndSetClass() {
    let hiddenCollections = hidePickingStoreCollections[pickingStore] || [];
    let hideCollections = hiddenCollections.includes(collectionHandle);

    // Set localStorage value
    localStorage.setItem(
      "hiddenCollections",
      hideCollections ? "true" : "false"
    );

    // Add or remove class on body
    if (hideCollections) {
      document.body.classList.add("hide-collections");
    } else {
      document.body.classList.remove("hide-collections");
    }
  }

  // Call the function
  if (collectionHandle) {
    checkAndSetClass();
  }

  // Update picking store links.
  if(localStorage.getItem('activeDelivery') === 'true') {
    collections.forEach(function (collection) {
      let newFileName = collection + appendFilename;
      $("a[href='/collections/" + collection + "']").attr(
        "href",
        "/collections/" + newFileName
      );

      // Updates links based on picking store.
      // Check if viewing correct picking store collection.
      let currCollection = Boolean(
        collection == filename.replace(/-[0-9]+$/g, "")
      );

      // Compare without appended pickingStore.
      if (currCollection && filename != newFileName) {
         // Redirect if not on correct picking store collection.
        location.href = "/collections/" + newFileName;
      }
    });
  }

  // Hide non applicable collections from menu.
  for (let key in hidePickingStoreCollections) {
    if (key == pickingStore) {
      hidePickingStoreCollections[key].forEach(function (collectionHandle) {
         $(".sidebar_menu li button").filter(function() {
           return $(this).text().trim().toLowerCase() === collectionHandle.toLowerCase();
        }).hide();
      });
    }
  }

  // Hide liquor from menu if applicable.
  //if (hideAlcohol) {
  //$(".sidemenu-submenu__container .sub-menu li a a[href*='liquor']").hide();
  //}
}

document.addEventListener("DOMContentLoaded", function () {
  
  document.addEventListener("keydown", function (event) {
    // Check if the ESC key is pressed
    if (event.key === "Escape" || event.keyCode === 27) {
      // Find the modal element
      var modal = document.querySelector(".search-modal.modal__content");

      // Check if the modal has the 'open_modal' class
      if (modal && modal.classList.contains("open_modal")) {
        // Remove the 'open_modal' class to close the modal
        modal.classList.remove("open_modal");
        //self.searchModal.classList.remove("open_modal");
        document.body.classList.remove("open__overlay", "overflow-hidden-tablet");
      }
    }
  });

  // Retrieve the data from localStorage
  const failedItemsData = localStorage.getItem("failedItems");

  // Check if there's any data to display
  if (failedItemsData && failedItemsData !== '""') {
    // Checks for non-empty string representation of an empty array
    const failedItems = JSON.parse(failedItemsData);

    // Only proceed if failedItems is not empty
    if (failedItems.length > 0) {
      // Find the element to which you want to append the data
      const displayElement = document.querySelector(".unavailable-items");
      const displayElementList = document.querySelector(
        ".unavailable-items-list"
      );

      if (displayElement) {
        displayElement.classList.add("show-unavailable-items");
        // Ensure the list is empty before adding items
        displayElementList.innerHTML = "";

        // Create a <ul> element
        const list = document.createElement("ul");

        // Iterate over failedItems and append each as an <li>
        failedItems.forEach((item) => {
          const listItem = document.createElement("li");
          listItem.textContent = item; // Set the text content to the item
          list.appendChild(listItem); // Append the <li> to the <ul>
        });

        // Append the <ul> to the display element
        displayElementList.appendChild(list);
      }
    }
    // Clear the localStorage
    localStorage.removeItem("failedItems");
  }

  // Find the close button
  const closeButton = document.querySelector(".close-unavailable-items");

  if (closeButton) {
    // Add click event listener to the close button
    closeButton.addEventListener("click", () => {
      // Find the element with the .unavailable-items class
      const unavailableItemsElement =
        document.querySelector(".unavailable-items");

      if (unavailableItemsElement) {
        // Remove the .show-unavailable-items class
        unavailableItemsElement.classList.remove("show-unavailable-items");
      }
    });
  }

  // Select all .search__input elements on the page
  const searchInputs = document.querySelectorAll(".search__input");

  // Function to synchronize all search input values
  function syncSearchInputs(sourceValue) {
    searchInputs.forEach((input) => {
      input.value = sourceValue;
    });
  }

  // Add input event listener to each search input
  searchInputs.forEach((input) => {
    input.addEventListener("input", function () {
      // Call sync function with the current value of the input being typed in
      syncSearchInputs(this.value);
    });
  });
});
